import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegistreService {

    private basePathAutorizari = environment.interop.autcomCore.basePath;
    private getRegistreAutorizariListURL = this.basePathAutorizari + environment.interop.autcomCore.registre.getRegistre;
    private getRegistreAutorizariValabilityURL = this.basePathAutorizari + environment.interop.autcomCore.registre.getRegistreValability;

    private basePathUrbanism = environment.interop.urbanismCore.basePath;
    private getRegistreUrbanismListURL = this.basePathUrbanism + environment.interop.urbanismCore.registre.getRegistre;

    constructor(private http: HttpClient) { }

    getRegistreAutorizari() {
        return this.http
            .get<{ errors: boolean, data: any[], status_code: number }>(
                this.getRegistreAutorizariListURL
            )
            .pipe(
                map((res) =>
                    res.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug
                    }))
                ),
                catchError((err) => {
                    console.log('Error in get registre autorizari types: ', err);
                    return throwError(err);
                })
            )
    }

    getRegistreAutorizariValability(registruId: number) {
        return this.http
            .post<{ errors: boolean, data: number[], status_code: number }>(
                this.getRegistreAutorizariValabilityURL, { type: registruId }
            )
            .pipe(
                map((res) =>
                    res.data.map((item) => ({
                        id: item,
                        name: item.toString(),
                    }))
                ),
                catchError((err) => {
                    console.log('Error in get registre autorizari valability: ', err);
                    return throwError(err);
                })
            )
    }

    getRegistreUrbanism(filter?: 'archived' | 'active') {
        let params = new HttpParams();
        if (filter !== undefined) {
            params = params.set('archived', filter === 'archived' ? '1' : '0');
        }

        return this.http
            .get<{ errors: boolean, data: any[], status_code: number }>(
                this.getRegistreUrbanismListURL, { params }
            )
            .pipe(
                map((res) =>
                    res.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug
                    }))
                ),
                catchError((err) => {
                    console.log('Error in get registre urbanism types: ', err);
                    return throwError(err);
                })
            )
    }
}
